<template>
    <div class="paginator">

        <!--
        <div class="dropdown-container">
            <div class="dropdown-text">
                <p>{{ pageCount }} pages</p>
            </div>
            <div class="dropdown-icon">
                <img src="/icons/icon_arrow-forward.png"/>
            </div>
        </div> 
        -->

        <div class="inline">
            <ul>
                <li><a @click="gotoFirst" class="left-border" href="#">&lt;&lt;</a></li>
                <li><a @click="gotoPrevious" href="#">&lt;</a></li>
                <li v-if="showFirst"><a @click="gotoFirst" href="#">1</a></li>
                <li v-if="showGapPrior"><a href="#">...</a></li>
                <li v-if="showPageLessOne"><a @click="gotoPrevious" href="#">{{ currentPage - 1 }}</a></li>
                <li><a class="active" href="#">{{ currentPage }}</a></li>
                <li v-if="showPagePlusOne"><a @click="gotoNext" href="#">{{ currentPage + 1 }}</a></li>
                <li v-if="showGapFuture"><a href="#">...</a></li>
                <li v-if="showLast"><a @click="gotoLast" href="#">{{ pageCount }}</a></li>
                <li><a @click="gotoNext" href="#">&gt;</a></li>
                <li><a @click="gotoLast" class="right-border" href="#">&gt;&gt;</a></li>                
            </ul>
        </div>

    </div>
</template>

<script>

    export default {

        props: ['pageData'],

        computed: {

            currentPage: function() {
                return this.pageData.currentPage;
            },
            canGoBack: function() {
                return this.currentPage !== 1;
            },
            canGoForward: function() {
                return this.currentPage < this.pageCount;
            },
            pageCount: function() {
                
                let total = this.pageData.totalItems;
                let size = this.pageData.pageSize;

                let quotient = Math.floor(total/size);
                let remainder = total % size;

                return remainder === 0 ? quotient : quotient + 1;
            },
            showPageLessOne: function() {
                // determines whether to show the prior page number in the bar
                return this.currentPage > 1;
            },
            showPagePlusOne: function() {
                // determines whether to show the next page number in the bar
                return this.currentPage < this.pageCount;
            },
            showGapPrior: function() {
                // determines whether to show a prior gap placeholder in the bar
                return this.currentPage > 3;
            },
            showGapFuture: function() {
                // determines whether to show a future gap placeholder in the bar
                return this.currentPage + 2 < this.pageCount;
            },
            showFirst: function() {
                // determines whether to show the first page in the bar, before a prior gap
                return this.showGapPrior || this.currentPage > 2;
            },
            showLast: function() {
                // determines whether to show the last page in the bar, after a future gap
                return this.showGapFuture || this.currentPage + 1 < this.pageCount;
            }
        },

        methods: {
            gotoFirst: function() {
                if (!this.canGoBack) return;
                //alert('going first')
                this.pageData.getPage(1);
            },
            gotoLast: function() {
                if (!this.canGoForward) return;
                //alert('going last')
                this.pageData.getPage(this.pageCount);
            },
            gotoNext: function() {
                if (!this.canGoForward) return;
                //alert('going next')
                this.pageData.getPage(this.currentPage + 1);
            },
            gotoPrevious: function() {
                if (!this.canGoBack) return;
                //alert('going previous')
                this.pageData.getPage(this.currentPage - 1);
            }
        }
    }

</script>